/**
 * maps.js starts
 * Created by mac on 24.08.2018.
 */
/**Возвращает выборку городов из списка с обжарщиками*/
function getCities(data) {
	var _cities = _.pluck(data, "city");
	return _.indexBy(_cities, "id");
}
/*В эту переменную записываются данные, необходимые для функционирования карты обжарщиков*/
window.kroasters = {
	map: "",
	markers: {
		0: []
	},
	clusters: {},
	cards: {},
	bounds: "",
	infowindow: "",
	desktopwidth: 992,
	createMap: function (data) {
		if (data === undefined) return false;
		var mapCenter = {
				lat: 55.76,
				lng: 37.64,
			},
			bounds = new google.maps.LatLngBounds();
		this.map = new google.maps.Map(document.getElementById("roasters-map"), {
			center: mapCenter,
			zoom: 10,
		});
		this.infowindow = new google.maps.InfoWindow();
		var roastersList = document.getElementById("roasters-list"),
			markersList = [],
			roastersMarkersList = [],
			suppliersMarkersList = [];
		this.prepareCollections(data); //подготавливаем массивы, куда будем записывать маркеры и карточки
		this.drawCityFilter(data); //рисуем фильтр по городам
		/*Добавляем маркеры на карту*/
		for (var i = 0; i < data.length; i++) {
			var curr = data[i],
				currChecked = this.processingData(curr),
				coords = curr.coords.split(","),
				latLng = new google.maps.LatLng(coords[0], coords[1]),
				marker = this.addMarker(latLng, currChecked, data[i].isRoaster) //маркеры
			// card = this.addRoasterCard(roastersList, currChecked, latLng); //карточки обжарщиков
			this.markers[0].push(marker);
			// this.markers[curr.city.id].push(marker); //группируем маркеры по городам для дальнейших манипуляций
			// this.cards[curr.city.id].push(card); //группируем карточки по городам
			bounds.extend(latLng); //расширяем границы карты, чтобы влезли все обжарщики
			data[i].isRoaster ? roastersMarkersList.push(marker) : suppliersMarkersList.push(marker);
			markersList.push(marker);
		}
		//добавляем кластеризацию
		kroasters.clusters.roasters = new MarkerClusterer(this.map, roastersMarkersList, {
			imagePath: "/img/markers/f",
			ignoreHidden: true,
		});
		kroasters.clusters.suppliers = new MarkerClusterer(this.map, suppliersMarkersList, {
			imagePath: "/img/markers/g",
			ignoreHidden: true,
		});
		// markersList = suppliersMarkersList.concat(roastersMarkersList)
		this.map.fitBounds(bounds); //помещаем всех обжарщиков на одном экране
		this.bounds = bounds; //сохраняем во внешнюю переменную границы  всех обжарщиков (в будущем пригодится)
	},
	/**drawCityFilter - добавляет select со списком городов*/
	drawCityFilter: () => {
		let select = document.createElement("select");
		let option = document.createElement("option");
		let option1 = document.createElement("option");
		let option2 = document.createElement("option");
		option.innerText = "Показать всех";
		option1.innerText = "Показать поставщиков";
		option2.innerText = "Показать обжарщиков";
		option.value = "";
		option1.value = "suppliers";
		option2.value = "roasters";
		select.append(option, option1, option2);
		select.addEventListener("change", () => {
			kroasters.filterMarkers(select.value);
		});
		document.getElementById("city-filter-wrapper")
			.appendChild(select);
		const choices = new Choices(select, {
			itemSelectText: "",
			searchEnabled: false,
			shouldSort: false,
		});
	},
	/**Подготавливает два массива, куда в дальнейшем будут записываться маркеры и карточки
	 * */
	prepareCollections: function (data) {
		if (data === undefined) return false;
		var cities = getCities(data),
			ids = _.pluck(cities, "id");
		for (var i = 0; i < ids.length; i++) {
			kroasters.markers[ids[i]] = [];
			kroasters.cards[ids[i]] = [];
		}
	},
	/**Добавление маркера на карту*/
	addMarker: function (latLng, data, isRoaster) {
		var iconBase = "/img/markers/",
			icons = {
				roaster: {
					icon: iconBase + (isRoaster ? "roaster.png" : "supplier.png"),
				},
			},
			marker = new google.maps.Marker({
				position: latLng,
				map: kroasters.map,
				icon: icons.roaster.icon,
				title: name,
				category: isRoaster ? "roasters" : "suppliers",
			}),
			markerData = this.processingData(data),
			_infowindow = _.template(getTpl("roasterCardTpl")); //шаблонизатор underscore.js
		// _infowindow = _.template(getTpl("infoWindowTpl")); //шаблонизатор underscore.js
		// markerData.biba = "biba";
		google.maps.event.addListener(marker, "click", function () {
			var infowindowContent = _infowindow(data); //результат работы шаблонизатора underscore.js
			if (infowindowContent) {
				kroasters.infowindow.setContent(infowindowContent);
				kroasters.infowindow.open(kroasters.map, marker);
			}
		});
		return marker;
	},
	filterMarkers: function (category) {
		for (const [key, markersArr] of Object.entries(this.markers)) {
			markersArr.forEach((markerItem) => {
				if (markerItem.category == category || category.length == 0) {
					markerItem.setMap(null);
				} else {
					markerItem.setMap(this.map);
				}
			});
		}
		kroasters.clusters.roasters.clearMarkers();
		kroasters.clusters.suppliers.clearMarkers();
		if (category == "roasters") {
			let markers = [];
			for (const [key, markersArr] of Object.entries(this.markers)) {
				markersArr.forEach((markerItem) => {
					if (markerItem.category == "roasters") {
						markers.push(markerItem);
					}
				});
			}
			kroasters.clusters.roasters.addMarkers(markers);
		} else if (category == "suppliers") {
			let markers = [];
			for (const [key, markersArr] of Object.entries(this.markers)) {
				markersArr.forEach((markerItem) => {
					if (markerItem.category == "suppliers") {
						markers.push(markerItem);
					}
				});
			}
			kroasters.clusters.suppliers.addMarkers(markers);
		} else {
			let markersR = [],
				markersS = [];
			for (const [key, markersArr] of Object.entries(this.markers)) {
				markersArr.forEach((markerItem) => {
					if (markerItem.category == "suppliers") {
						markersS.push(markerItem);
					} else if (markerItem.category == "roasters") {
						markersR.push(markerItem);
					}
				});
			}
			kroasters.clusters.roasters.addMarkers(markersR);
			kroasters.clusters.suppliers.addMarkers(markersS);
		}
	},
	/**Подготавливает данные об обжарщиках для размещения на карте и в карточке обжарщика
	 * @param {object} data - входные данные
	 * @return {object}
	 * Добавляет недостающие поля (по умолчанию)
	 * */
	processingData: function (data) {
		var res = {
			//значения по умолчанию
			name: "Безымянный обжарщик",
			logo: "",
			social: [],
			isRoaster: true
		};
		var props = ["name", "address", "link", "url", "social", "logo", "phone", "email", "roasters", "description", "isRoaster"];
		_.map(props, function (prop) {
			if (data[prop] !== undefined) {
				var property = data[prop];
				// if (prop === "url") {
				// 	property = property.replace("https://", "");
				// 	property = property.replace("http://", "");
				// }
				res[prop] = property;
			}
		});
		return res;
	},
	/**Добавление карточки обжарщика (над картой)
	 * @param {element} container - элемент-контейнер, куда добавлять карточку
	 * @param {object} data - данные для заполнения карточки
	 * @param {object} coords - объект google map latLng, нужен при назначении обработчика события клика по карточке (для центрации карты)
	 * */
	addRoasterCard: function (container, data, coords) {
		var _roasterCard = _.template(getTpl("roasterCardTpl")),
			roasterCard = _roasterCard(data),
			card = document.createElement("div");
		card.classList.add("sm-card");
		card.innerHTML = roasterCard;
		card.addEventListener("click", function (e) {
			if (!$(e.target)
				.is("a")) {
				if (coords) kroasters.map.setZoom(12);
				kroasters.map.panTo(coords);
			}
		});
		container.appendChild(card);
		return card;
	},
	filterRoasters: function (filter) {
		var markers,
			cards = this.cards,
			bounds = this.bounds;
		if (parseInt(filter) > 0) {
			//если выбран конкретный город
			//1. фильтруем маркеры на карте
			markers = this.markers[filter];
			if (markers.length > 1) {
				bounds = new google.maps.LatLngBounds();
				_.map(markers, function (marker) {
					bounds.extend(marker.getPosition());
				});
				this.map.fitBounds(bounds);
			} else {
				this.map.setZoom(13);
				this.map.panTo(markers[0].getPosition());
			}
			//2. фильтруем карточки в списке
			_.map(cards, function (cardgroup, k) {
				if (parseInt(k) !== parseInt(filter)) $(cardgroup)
					.hide();
				else $(cardgroup)
					.show();
			});
		} else {
			//если выбран пункт "Все"
			kroasters.map.fitBounds(bounds);
			_.map(cards, function (cardgroup, k) {
				$(cardgroup)
					.show();
			});
		}
	},
};
$(function () {
	/*Создаем карту обжарщиков*/
	if ($("#roasters-map")
		.length && ROASTERS_LIST !== undefined) {
		kroasters.createMap(ROASTERS_LIST);
		if ($(document.body)
			.innerWidth() > kroasters.desktopwidth) {
			$(".roasters-list")
				.jScrollPane({
					autoReinitialise: true,
				});
		}
	}
	/*Фильтруем карту обжарщиков по городам*/
	$(document)
		.on("change", "#city-filter", function (e) {
			var cityid = this.value;
			if (cityid) {
				kroasters.filterRoasters(cityid);
			}
		});
});
/* maps.js ends */
